<template>
  <hdraces-tickets-list :data-func="getTickets" :show-user="true" />
</template>
<script>
  import hdracesService from '../../../../../services/hdraces.service'

  import hdracesTicketsList from '../../../../common/hdraces-tickets-list.vue'

  export default {
    name: 'player-hdraces-bets',
    components: { hdracesTicketsList },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      },
      playerId() {
        return this.$route.params.playerId;
      }
    },
    methods: {
      async getTickets(filter) {
        filter.clientId = this.clientId;
        filter.userId = this.playerId;
        return await hdracesService.get(filter);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/players/player/hdraces-bets.vue